export default {
  'products.name': 'Dish',
  'products.create': 'Add food',
  'products.update': 'Update food',
  'products.information': 'Food information',
  'products.delete.title': 'Delete food',
  'products.delete.content':
    'You are sure to delete food.The deleted dish will not help but admire ',
  'products.productsName': 'The name of food',
  'products.productsImage': 'Picture',
  'products.productsPrice': 'Price',
  'products.internalComment': 'Detail',
  'product.add': 'Create products',
  'product.back': 'Return',
  'products.productsQuantity': 'Quantity',
};
